import find from 'lodash/find';
import get from 'lodash/get';
import React, { FC } from 'react';
import styled from 'styled-components';

import ConditionRow from './ConditionRow';
import { CustomAttributeNumberCondition as CustomAttributeNumberConditionType } from 'src/actions/rules/condition';
import NumericConditionSection from '../shared/NumericConditionSection';
import { StyledConditionLabel } from '../shared/StyledComponents';
import { Tooltip } from 'src/presentation/components/agent_desktop_components';
import useCustomAttributes from '../hooks/useCustomAttributes';

type CustomAttributeNumberConditionProps = {
  condition: CustomAttributeNumberConditionType;
  index: number;
  isReadOnly?: boolean;
  onDelete: Function;
  onUpdate: Function;
};

const CustomAttributeNumberCondition: FC<CustomAttributeNumberConditionProps> = ({
  condition,
  index,
  isReadOnly,
  onDelete,
  onUpdate,
}) => {
  const label = get(find(useCustomAttributes(), { attr: condition.name }), 'label');

  if (isReadOnly) {
    return (
      <>
        <StyledRow index={index} isReadOnly onDelete={onDelete}>
          <SelectorRow>
            <StyledConditionLabel disabled data-aid="readOnlyNumberConditionLabel">
              {label}
            </StyledConditionLabel>
            <NumericConditionSection isReadOnly condition={condition} index={index} onUpdate={onUpdate} />
          </SelectorRow>
        </StyledRow>
      </>
    );
  }
  return (
    <StyledRow index={index} onDelete={onDelete}>
      <SelectorRow>
        <Tooltip message={label}>
          <ConditionLabel disabled data-aid="numberConditionLabel">
            {label}
          </ConditionLabel>
        </Tooltip>
        <NumericConditionSection condition={condition} index={index} onUpdate={onUpdate} />
      </SelectorRow>
    </StyledRow>
  );
};

const ConditionLabel = styled(StyledConditionLabel)`
  margin-right: 6px;
  max-width: 160px;
`;

const SelectorRow = styled.div`
  align-items: center;
  display: flex;
  padding-bottom: 12px;
`;

const StyledRow = styled(ConditionRow)`
  align-items: baseline;
`;

export default CustomAttributeNumberCondition;
